import { jsx as i } from "react/jsx-runtime";
import { clsx as q } from "../../../utils/clsx.js";
import '../../../assets/Pad.css';const y = "_root_166qt_1", o = {
  root: y,
  "offset-none": "_offset-none_166qt_1",
  "offset-thin": "_offset-thin_166qt_4",
  "offset-xsmall": "_offset-xsmall_166qt_7",
  "offset-small": "_offset-small_166qt_10",
  "offset-normal": "_offset-normal_166qt_13",
  "offset-large": "_offset-large_166qt_16",
  "offset-xlarge": "_offset-xlarge_166qt_19",
  "only-top": "_only-top_166qt_22",
  "only-left": "_only-left_166qt_25",
  "only-right": "_only-right_166qt_28",
  "only-bottom": "_only-bottom_166qt_31"
};
function h(_) {
  const {
    top: f = !1,
    left: l = !1,
    right: s = !1,
    bottom: e = !1,
    size: n = "normal",
    children: r,
    className: a
  } = _, t = !(f || l || s || e), m = q(o.root, a, o[`offset-${n}`], {
    [o["only-top"]]: t || f,
    [o["only-left"]]: t || l,
    [o["only-right"]]: t || s,
    [o["only-bottom"]]: t || e
  });
  return /* @__PURE__ */ i("div", { className: m, children: r });
}
export {
  h as Pad
};
